// 小时分秒补零
const addZeor = function(num) {
  return num < 10 ? '0' + num : num
}

// 时间戳转日期
const timeTodate = function(timestamp, format) {
  var formateArr = ['Y', 'm', 'd', 'H', 'i', 's']
  var returnArr = []

  if (parseInt(timestamp) === 0 || isNaN(parseInt(timestamp))) {
    return '-'
  }

  var date = new Date(parseInt(timestamp))

  returnArr.push(date.getFullYear())

  var month = date.getMonth() + 1
  month = month < 10 ? '0' + month : month
  returnArr.push(month)

  var day = date.getDate()
  day = day < 10 ? '0' + day : day
  returnArr.push(day)

  var hours = date.getHours()
  hours = hours < 10 ? '0' + hours : hours
  returnArr.push(hours)

  var minute = date.getMinutes()
  minute = minute < 10 ? '0' + minute : minute
  returnArr.push(minute)

  var second = date.getSeconds()
  second = second < 10 ? '0' + second : second
  returnArr.push(second)

  returnArr.forEach(function(v, i) {
    format = format.replace(formateArr[i], returnArr[i])
  })
  return format
}

const timeToHour = function(timestamp) {
  // 确保时间戳是13位（毫秒级）
  timestamp = timestamp.toString().length === 10 ? timestamp * 1000 : timestamp;
  
  let times = parseInt((Date.now() - timestamp) / 1000);
  let str = '';
  
  if (times > 86400*7) {
    str = timeTodate(timestamp, 'm-d'); // 假设timeTodate是已定义的日期格式化函数
  } else if (times > 86400) {
    str = Math.floor(times / 86400) + '天前'; // 修正：计算完整天数
  } else if (times > 3600) {
    str = Math.floor(times / 3600) + '小时前'; // 修正：计算完整小时数
  } else if (times > 60) {
    str = Math.floor(times / 60) + '分钟前'; // 修正：计算完整分钟数
  } else {
    str = '刚刚';
  }
  
  return str;
}

const mobileEncryption = function(mobile) {
  let mobileStr = mobile.toString()
  return mobileStr.substring(0, 3) + '****' + mobileStr.substring(8, 11)
}

module.exports = {
  mobileEncryption,
  timeToHour,
  timeTodate,
  addZeor
}
